

































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

@Component
export default class AuthForm extends Vue {
  public form = {
    login: '',
    password: '',
  };

  mounted() {
    console.log('mount')
    document.documentElement.classList.remove('has-aside-left')
    document.documentElement.classList.remove('has-navbar-fixed-top')
  }

  destroyed() {
    console.log('unmount')
    document.documentElement.classList.add('has-aside-left')
    document.documentElement.classList.add('has-navbar-fixed-top')
  }

  public messages = {
    'incorrect login or password': 'Не верно заполен логин или пароль',
  };

  public validationError: string | null = null;

  public changeLogin($event: any) {
    this.form.login = $event.target.value;
  }

  public changePass($event: any) {
    this.form.password = $event.target.value;
  }

  public login(form: any) {
    this.$store.dispatch('ubic/login', form)
    .then(() => {
      console.log('then');
    })
    .catch((error: string) => {
      console.log(`catch: ${error}`);

      this.validationError = error;
    });
    //
  }
}
